import request from '@/util/request';
import qs from 'qs';

export const regionSelections = (params, options) =>
  request.post('/api/park/region/selections', qs.stringify(params), options);

export const getList = (params, options) =>
  request.get('/api/park/region/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/park/region/detail', Object.assign({}, options, { params }));

export const beforeDelete = (params, options) =>
  request.post('/api/park/region/beforeDelete', qs.stringify(params), options);

export const remove = (params, options) =>
  request.post('/api/park/region/remove', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/park/region/save', params, options);

export const update = (params, options) => request.post('/api/park/region/update', params, options);
